import { resetSelect } from 'reactApp/modules/selections/selections.actions';
import { store as reduxStore } from 'reactApp/store';

export const back = () => {
    reduxStore.dispatch(resetSelect());
};
